import AddTransferTemplatePage from "components/pages/AddTransferTemplatePage";

/**
 * @name CaptureAddTemplateMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureAddTemplateMain(props) {
    return <AddTransferTemplatePage/>;
}